import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StartService } from '../services/start.service';

const EXCLUDED_PATHS = [
  '/start/livechat',
  '/api/auth/refreshToken',
  '/auth/logout',
];

@Injectable()
export class SessionGateInterceptor implements HttpInterceptor {
  constructor(private startService: StartService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.externalUrls.bff)) {
      return next.handle(request);
    }

    if (this.isExcluded(request.url)) {
      return next.handle(request);
    }

    return this.startService.sessionSettled$.pipe(
      switchMap(() => next.handle(request))
    );
  }

  private isExcluded(url: string): boolean {
    return EXCLUDED_PATHS.some((path) => url.includes(path));
  }
}
